// Names are a routing hint only. The browser/decoder still validates the bytes.
export const IMAGE_MIMES = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif',
  'image/avif', 'image/bmp', 'image/heif', 'image/heic', 'image/tiff', 'image/x-icon']);
const aliases = {'image/jpg':'image/jpeg', 'image/pjpeg':'image/jpeg', 'image/x-png':'image/png',
  'image/x-ms-bmp':'image/bmp', 'image/x-tiff':'image/tiff', 'image/vnd.microsoft.icon':'image/x-icon'};
const extensions = {jpg:'image/jpeg', jpeg:'image/jpeg', jpe:'image/jpeg', png:'image/png',
  webp:'image/webp', gif:'image/gif', avif:'image/avif', bmp:'image/bmp', heic:'image/heic',
  heif:'image/heif', tif:'image/tiff', tiff:'image/tiff', ico:'image/x-icon'};
const generic = new Set(['', 'application/octet-stream', 'binary/octet-stream', 'application/x-octet-stream',
  'application/force-download', 'application/download', 'application/x-download']);
export function imageMime(node) {
  const extension = String(node?.name || '').split('.').pop().toLowerCase();
  if (['svg', 'svgz', 'html', 'htm', 'xhtml', 'xml'].includes(extension)) return '';
  const raw = String(node?.mime || node?.mime_type || '').split(';')[0].trim().toLowerCase();
  const mime = aliases[raw] || raw;
  if (IMAGE_MIMES.has(mime)) return mime;
  if (!generic.has(mime)) return ''; // HTML/SVG or another explicit type never becomes an inline image.
  return extensions[extension] || '';
}
export const rasterImage = node => node?.kind === 'file' && Boolean(imageMime(node));
export const heicImage = node => ['image/heic', 'image/heif'].includes(imageMime(node));
